export default __webpack_public_path__ + "static/1778726682f7d59147d33ab1937548d2.ttf";